import React, { useLayoutEffect, useRef } from "react";
import TreeChart from "d3-org-chart";
import ReactToPrint from "react-to-print";
import { Button, Col, Row } from "react-bootstrap";

const PrintButton = ({ chartRef }) => {
  return (
    <ReactToPrint
      trigger={() => (
        <Button
          variant="light"
          size="sm"
          className="d-flex align-items-center rounded-circle ml-auto mr-0"
        >
          <i className="material-icons mr-1">print</i>
        </Button>
      )} // Botón que inicia la impresión
      content={() => chartRef.current} // Contenido que se imprimirá
      documentTitle="Estructura Organizacional F-052"
    />
  );
};

const OrgChart = (props) => {
  const d3Container = useRef(null);
  let chart = null;

  useLayoutEffect(() => {
    if (props.data && d3Container.current) {
      if (!chart) {
        chart = new TreeChart();
      }
      chart
        .container(d3Container.current)
        .data(props.data)
        .svgWidth(500)
        .initialZoom(0.4)
        .onNodeClick((d) => {
          //console.log(d + " node clicked");
          //console.log("props", Object.keys(props), d);
          props.onNodeClick(d);
        })
        .render();
      // props.appendData.forEach(node => {
      //   chart.addNode(node);
      // });
    }
  }, [props.data, d3Container.current]);
  return (
    <>
      <Col className="mb-4 mt-2">
        <Row>
          <h5 className="font-weight-bold text-uppercase">{props.name}</h5>
          <PrintButton chartRef={d3Container} />
        </Row>
      </Col>
      <hr />
      <div className="print-class" ref={d3Container}></div>
    </>
  );
};

export default OrgChart;
